import { createContext, useContext } from 'react'
import type { EventDetails } from '../api/types'

export interface SessionGuest {
  guestId: string
  displayName: string
}

export interface Session {
  slug: string

  /** Het feest zoals de API het teruggeeft. */
  event: EventDetails

  /** Null zolang de bezoeker zijn naam nog niet heeft ingevuld. */
  guest: SessionGuest | null

  /** Registreert of hernoemt; werkt localStorage en de server allebei bij. */
  /**
   * Meldt deze bezoeker aan bij het feest.
   *
   * Met `useOwnerAccount` komt de naam uit de eigenaarssessie in plaats van uit
   * `displayName` — dan hoeft de eigenaar van het feest niet in te typen hoe
   * hij heet.
   */
  saveGuest: (displayName: string, useOwnerAccount?: boolean) => Promise<SessionGuest>

  /** "Uitloggen": naam én invite token weg. */
  signOut: () => void
}

export const SessionContext = createContext<Session | null>(null)

export function useSession(): Session {
  const session = useContext(SessionContext)

  if (!session) {
    throw new Error('useSession hoort binnen een <SessionProvider>.')
  }

  return session
}
